module.exports = __webpack_public_path__ + "images/curve-arrow-down.071ac9e2d6e9707a1b4daba690579258.svg";